/** @file Client-side navigation: pushes (or replaces) a history entry and updates the route store. */
import { routeStore } from '../../stores/routeStore';
import { parseRoute } from './parseRoute';

/** The address bar's path, query and hash, or null outside a browser. */
function currentUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const { pathname, search, hash } = window.location;
  return pathname + search + hash;
}

// Routing ignores `?query` and `#hash` (the URL keeps them); the current URL adds no history entry but still notifies.
/** Goes to an app path such as `/p/proj_…`; `replace` is for redirects; `history` and `current` are injectable for tests. */
export function navigate(
  path: string,
  options: { replace?: boolean } = {},
  history: Pick<History, 'pushState' | 'replaceState'> = window.history,
  current: string | null = currentUrl(),
): void {
  if (path !== current) {
    if (options.replace === true) history.replaceState(null, '', path);
    else history.pushState(null, '', path);
  }
  routeStore.setState({ route: parseRoute(path.replace(/[?#].*/s, '')) });
}
